/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostawsauthrolearnPostBody
 */
export interface JumboPostawsauthrolearnPostBody {
    /**
     * 
     * @type {string}
     * @memberof JumboPostawsauthrolearnPostBody
     */
    roleARN: string;
}

/**
 * Check if a given object implements the JumboPostawsauthrolearnPostBody interface.
 */
export function instanceOfJumboPostawsauthrolearnPostBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roleARN" in value;

    return isInstance;
}

export function JumboPostawsauthrolearnPostBodyFromJSON(json: any): JumboPostawsauthrolearnPostBody {
    return JumboPostawsauthrolearnPostBodyFromJSONTyped(json, false);
}

export function JumboPostawsauthrolearnPostBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostawsauthrolearnPostBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roleARN': json['roleARN'],
    };
}

export function JumboPostawsauthrolearnPostBodyToJSON(value?: JumboPostawsauthrolearnPostBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roleARN': value.roleARN,
    };
}

